import { VillageClient } from 'pages'
import React from 'react'
import { useParams } from 'react-router-dom'

export const VillageClientWrapper = () => {
    const { villageId } = useParams()
    const goBackTo = `/fc/village/${villageId}/profile`

    return <VillageClient goBackTo={goBackTo} showBack showEnrollmentQr />
}
